module.exports = __webpack_public_path__ + "static/mini_calendar_formula-969d74e05686f54bf9ac5cb3aad10858.png";